import React from "react";
import { MobileHorizontalRule } from "./HorizontalRule";

const PageHeading = ({ children }: { children: React.ReactNode }) => {
	return (
		<>
			<div className="to-lg:flex-col flex justify-between pb-9 lg:items-center lg:pb-14">
				<h1 className="text-32px lg:text-50px">{children}</h1>
			</div>
			<MobileHorizontalRule />
		</>
	);
};

export default PageHeading;
